import SessionEventProto from "../session-event-proto";
import Company from "../../model2/company/company";


export default class SessionEvent_CompanyNew extends SessionEventProto {


    constructor(sessionEvent:any) {
        super(sessionEvent)
    }


    process() {

        const newModel = new Company(this.data)

        gd.session.companies.add(newModel)
        gd.session.companies.sort()

        gd.initCurOrganizationId()


    }
}

// const EventCompanyNew = function(uid,data) {
//
//     this.data = data;
//     this.uid = uid;
// };
//
// EventCompanyNew.prototype.validate = function(){
//     return true;
// };
//
// EventCompanyNew.prototype.process = function(){
//
//
//
// };
//
//
// module.exports = EventCompanyNew;

